export type TestimonialSlot = {
  title: string;
  text: string;
  name: string;
  isPublished: boolean;
  isPreviewContent?: boolean;
};

// Contenido temporal para previsualizar la maquetación. Reemplazar por opiniones auténticas antes de publicar.
export const testimonialSlots: TestimonialSlot[] = [
  {
    title: "Me encantó cómo está explicado.",
    text: "Yo ya sabía el significado de varias cartas pero cuando hacía una tirada me costaba unir todo. Tenerlo ordenado así me resultó mucho más fácil para practicar.",
    name: "Mariana G.",
    isPublished: true,
    isPreviewContent: true,
  },
  {
    title: "Era justo lo que estaba buscando.",
    text: "Recién estoy empezando y siempre terminaba buscando cada carta por separado. Me gustó porque puedo tener la guía abierta mientras practico y consultar cuando me trabo.",
    name: "Carla M.",
    isPublished: true,
    isPreviewContent: true,
  },
  {
    title: "Súper completo y fácil de entender.",
    text: "Pensé que iba a ser uno de esos PDF llenos de teoría pero está muy bien organizado. Sobre todo me sirvió la parte de cartas invertidas porque era donde más dudas tenía.",
    name: "Florencia R.",
    isPublished: true,
    isPreviewContent: true,
  },
];
